import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play",
  "use": "play-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"play\"><path d=\"M8.028 3.29C6.695 2.493 5 3.453 5 5.007v13.988c0 1.554 1.695 2.514 3.028 1.715l11.675-6.993c1.296-.777 1.296-2.655 0-3.432L8.028 3.291Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol